// Browser-safe production identifiers. Environment variables may override them.
// Private provider credentials must never be added to this module.
export const publicConfig = {
  // Production uses the same-origin Pages /gateway relay. Local development can
  // still point at a Wrangler dev server with VITE_API_BASE_URL.
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "",
  supabaseUrl:
    import.meta.env.VITE_SUPABASE_URL ??
    "https://qshoevjedbyxgurumvdm.supabase.co",
  supabasePublishableKey:
    import.meta.env.VITE_SUPABASE_ANON_KEY ??
    "sb_publishable_e4nDh3T70I1_P4iG6TREig_oxrndXlq",
  turnstileSiteKey:
    import.meta.env.VITE_TURNSTILE_SITE_KEY ?? "0x4AAAAAAEPANqHrPiIFyyPZ",
} as const;
